//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    requestBody: {
        page_language: string;
        slug: string;
    };
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/anonymous/find-page -> post -> ${code}`);
    };
};

export const Response200IO = t.interface({
    result: t.union([t.null, t.undefined, t.interface({
        content: t.string,
        id: t.number,
        keywords: t.union([t.null, t.undefined, t.string]),
        page_description: t.union([t.null, t.undefined, t.string]),
        page_language: t.union([t.null, t.undefined, t.string]),
        seo_title: t.union([t.null, t.undefined, t.string]),
        slug: t.string,
        title: t.string,
        universe: t.string,
    })]),
});
export type Response200Type = {
    result?: null | undefined | {
        content: string;
        id: number;
        keywords?: null | undefined | string;
        page_description?: null | undefined | string;
        page_language?: null | undefined | string;
        seo_title?: null | undefined | string;
        slug: string;
        title: string;
        universe: string;
    };
};
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiProxyAnonymousFindPageRequest"
 */
export const openapi_proxy_anonymous_find_page = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/api-proxy/anonymous/find-page${query}`;
    
    const method = 'POST';
    const paramsFetch = {
        url,
        body: params.requestBody,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiProxyAnonymousFindPageParamsType = ParamsType;

export type OpenapiProxyAnonymousFindPageResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 400;
    body: Response400Type;
} | {
    status: 401;
    body: Response401Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiProxyAnonymousFindPageResponse200Type = Response200Type;

export const openapiProxyAnonymousFindPageRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiProxyAnonymousFindPageResponseType> => {
    const response = await openapi_proxy_anonymous_find_page(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiProxyAnonymousFindPageRequest - unhandled response ${response.status}`);
};

